const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M4.25 6.25A.75.75 0 0 1 5 5.5h14A.75.75 0 0 1 19 7H5a.75.75 0 0 1-.75-.75m0 11.5A.75.75 0 0 1 5 17h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75m.75-6.5a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z"/></svg>';
export {
  a as w
};
